// Integración con el SDK de Rebill (web components, Stencil). El componente
// `<rebill-checkout>` renderiza un checkout de suscripción EMBEBIDO usando solo
// el PUBLIC KEY (seguro para el front) + un `plan-id` del panel. No hace falta
// backend ni credenciales secretas para el checkout (el backend procesa webhooks).
//
// Este módulo registra los custom elements del SDK una sola vez (`ensureRebillSDK`).
// Docs: https://docs.rebill.com/sdk/checkout

import { REBILL_ENV } from '../config';

let registered = false;

/**
 * Registra los web components de Rebill (idempotente). Debe correr en el
 * browser antes de usar `<rebill-checkout>`.
 *
 * IMPORTANTE: usamos el bundle de *custom elements* (`rebill/rebill-checkout`),
 * que hace imports estáticos y es amigable con bundlers (Vite). NO usamos el
 * lazy loader (`rebill/loader` → `defineCustomElements`), que carga cada
 * componente por chunk `.entry.js` en runtime y rompe con el optimizador de
 * Vite (504 "Outdated Optimize Dep" + "Constructor ... was not found").
 */
export async function ensureRebillSDK(): Promise<void> {
  if (registered || typeof window === 'undefined') return;
  registered = true;

  // Configura el entorno del SDK (host de la API + assets desde el CDN).
  // Importamos de 'rebill/config' (barrel completo); el entry '.' del paquete
  // apunta solo al componente y no expone `initializeRebillSDK`.
  const { initializeRebillSDK } = await import('rebill/config');
  initializeRebillSDK({ environment: REBILL_ENV, debug: REBILL_ENV !== 'production' });

  // El subpath 'rebill/rebill-checkout' mapea sus TIPOS a index.d.ts (que no
  // exporta `defineCustomElement`), pero el archivo real sí lo exporta. Cast a
  // any para el destructuring; el runtime es correcto.
  const mod = (await import('rebill/rebill-checkout')) as any;
  if (!customElements.get('rebill-checkout')) {
    mod.defineCustomElement();
  }
  // Aseguramos que el custom element esté definido antes de usarlo.
  await customElements.whenDefined('rebill-checkout');
}
